import { AxiosService } from 'services';
export function GetStoreListService(uf, city) {
  return AxiosService(uf).get(`whats/stores?state=${uf}&city=${city}`)
    .then(function (response) {
      return response.data;
    }).catch(function (error) {
      console.log(error);
    });
}
